export default {
  credential: 'credential',
  editCredential: 'Edit credential',
  deleteCredential: 'Delete credential',
  addCredential: 'Add credential',
  credentialType: 'Credential type',
  credentialBackImage: 'Credential back image',
  credentialFrontImage: 'Credential front image',
  credentialCreatedSuccessfully: 'Credential created successfully',
  confirmed: 'confirmed',
  awaitingConfirmation: 'Awaiting confirmation'
}
